import React, { Component } from 'react';
import styled from 'styled-components';
import Select from 'react-select';
import '_Components/Fields/QSelect/style.scss';
import { grayShades, purple, black } from 'styles/abstracts/colors';
import { QSelectProps } from './QSelect.propTypes';

const StyledSelect = styled(Select)`
  ${({ width }) => (width ? `width: ${width}px !important;` : '')}
`;

const DEFAULT_CONFIG = {
  name: null,
  multi: false,
  placeholder: '',
  rtl: false,
  closeOnSelect: true,
  removeSelected: false,
  searchable: false,
  clearable: true,
  simpleValue: false,
};

class QSelect extends Component {
  prepareSelectConfig() {
    const { config = {} } = this.props;
    return { ...DEFAULT_CONFIG, ...config };
  }

  render() {
    const { value, options, onChange, disabled, width } = this.props;
    const config = this.prepareSelectConfig();
    return (
      <StyledSelect
        className="selectInput"
        value={value}
        onChange={onChange}
        options={options}
        isDisabled={disabled}
        width={width}
        styles={{
          option: (base, state) => ({
            ...base,
            cursor: !state.isDisabled && 'pointer',
            color: state.isDisabled && `${grayShades.g800} !important`,
            '&:hover': {
              backgroundColor: !state.isDisabled && `${grayShades.g400}!important`,
              color: !state.isDisabled && `${black}!important`,
            },
          }),
          singleValue: (base, state) => {
            const isSelectedDisabled = value.isDisabled;
            return {
              ...base,
              cursor: isSelectedDisabled ? 'not-allowed' : 'pointer',
              color: isSelectedDisabled ? `${grayShades.g800}!important` : purple,
            };
          },
        }}
        {...config}
      />
    );
  }
}

QSelect.propTypes = QSelectProps;

QSelect.defaultProps = {
  disabled: false,
  config: {},
};

export default QSelect;
